"use strict";

var Socket = {
  socket: undefined,
  key: undefined,
  wsProtocol: undefined,
  wsHost: undefined,
  onload: document.addEventListener('DOMContentLoaded', function () {
    Socket.init();
  }),
  init: function init() {
    if (Socket.key !== undefined) this.connect();
  },
  connect: function connect() {
    Socket.socket = new WebSocket(Socket.wsProtocol + "://" + Socket.wsHost + '?key=' + Socket.key);
    Socket.socket.onopen = function () {
      console.log("Connected " + Socket.key);
    };
    Socket.socket.onclose = function (event) {
      if (event.wasClean) {
        console.log('Connect closed ' + Socket.key);
      } else {
        setTimeout(function () {
          Socket.connect();
        }, 5000);
      }
      console.log('Code: ' + event.code);
      console.log('Reason: ' + event.reason);
    };
    Socket.socket.onmessage = function (event) {
      console.log(event.data);
      var data = JSON.parse(event.data);
      switch (data.type) {
        case 1:
          Notifications.receiveNotification(data.data);
          break;
        case 2:
        case 6:
        case 7:
          Messages.receiveMessage(data.data);
          break;
        case 3:
          setTimeout(function () {
            Messages.updateMessageStatusRead(data.data.id);
          }, 1000);
          break;
        case 8:
          Messages.showPopupAfterFirstMessageFromClient(data.data);
          break;
        case 9:
          // blocked message
          break;
        case 5:
          Messages.blockChatModule(data.data);
          break;
        default:
          break;
      }
    };
    Socket.socket.onerror = function (error) {
      console.log("Error " + error.message);
    };
  }
};